import * as React from "react";
const SvgEmailIcon = () => (
  <svg width={40} height={40} fill="none">
    <circle cx={20} cy={20} r={20} fill="#FBFBFB" />
    <path
      fill="#6366F1"
      d="M13.333 26.667c-.458 0-.85-.164-1.177-.49a1.608 1.608 0 0 1-.49-1.177V15c0-.458.164-.85.49-1.177.327-.326.72-.49 1.177-.49h13.333c.459 0 .851.164 1.178.49.327.327.49.72.49 1.177v10c0 .458-.164.85-.49 1.177-.326.327-.719.49-1.178.49H13.333ZM20 20.833l-6.667-4.166V25h13.333v-8.333L20 20.833Zm0-1.666L26.666 15H13.333L20 19.167Zm-6.667-2.5V15v10-8.333Z"
    />
  </svg>
);
export default SvgEmailIcon;
